import { GzDatetimeFilterWebComponent } from './component/GzDatetimeFilterWebComponent';

export { GzDatetimeFilterWebComponent };
